import React from "react";
import { motion, AnimatePresence, delay } from "framer-motion";
import "./partOne.scss";
import { zipImages } from "../../../untils/until";
import { duration } from "@mui/material";
import { useTranslation } from "react-i18next";

interface PartOneProps {
  // scrollPosition: number; // 新增属性用于接收滚动位置
  // mobile: boolean;//是否是移动端
}

const PartOne: React.FC<PartOneProps> = ({}) => {
  const i18n = useTranslation();
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
    },
  };

  const itemVariants = {
    hidden: { opacity: 0},
    visible: { opacity: 1},
  };

  return (
    <>
      {/* PC */}

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="part-content1"
      >
        <motion.img
          variants={itemVariants}
          transition={{ delay: 0.2, duration: 0.5 }}
          src="https://oss.tnworld.cn/eastern/assets/home/home-floor.png"
          alt="floor"
          className="floor"
          style={{ zIndex: 1}}
        />
        <motion.img
          variants={itemVariants}
          transition={{ delay: 0.2, duration: 0.5 }}
          src="https://oss.tnworld.cn/eastern/assets/home/home-roof.png"
          alt="roof"
          style={{ zIndex: 2}}
        />
        <motion.img
          variants={itemVariants}
          transition={{ delay: 1, duration: 1 }}
          src="https://oss.tnworld.cn/eastern/assets/home/home-logo1.png"
          alt="logo"
          className="logo"
          style={{ zIndex: 3}}
        />
        <div className="home-tip">{i18n.t('scroll_tip')}</div>
        <div id="water-bottom" className="water water-bottom filter-active flow-active"></div>
        <svg width="0" height="0">
          <filter id="water-filter">
            <feTurbulence id="feTurb" type="fractalNoise" baseFrequency="0.01 0.01" seed="7" numOctaves="2" />
            <animate xlinkHref="#feTurb" 
                      attributeName="baseFrequency" 
                      dur="120s" 
                      values="0.008 0.20;0.008 0.02" 
                      keyTimes="0;1"
                      calcMode="linear"
                      repeatCount="indefinite"/>
            <feDisplacementMap id="feDisp" in="SourceGraphic" scale="150" />
          </filter>
        </svg>
      </motion.div>
      {/* Mobile */}
    </>
  );
};

export default PartOne;
